// B3 링크 모드(단일 화면 — 스텝퍼 없음). URL 한 칸 + 클립보드 제안 pill + 메모.
// 차종·위치는 묻지 않는다(서버가 링크 있으면 빈 값 허용).
import React from 'react';
import { T, R } from '../../../theme';
import { question, Field, NoteBox, CtaBar, input, textarea, btnNavy, btnDisabled } from './bits';

var pill = { display: 'inline-flex', alignItems: 'center', maxWidth: '100%', height: 28, padding: '0 11px',
  borderRadius: R.pill, border: '1px solid ' + T.accentBd, background: T.accentTint, color: T.accentPress,
  fontSize: 11.5, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit', overflow: 'hidden',
  textOverflow: 'ellipsis', whiteSpace: 'nowrap' };

function StepLink(props) {
  var t = props.t;
  return (<React.Fragment>
    <div style={question}>{t('simpleB3LinkTitle')}</div>

    <Field label={t('evalFormListingUrl')} htmlFor="req-url" error={props.urlError}>
      <input id="req-url" type="url" dir="ltr" style={input} value={props.url} placeholder="https://"
        onChange={function (e) { props.onUrl(e.target.value); }} />
    </Field>
    {props.clipboardHost ? (<div>
      <button type="button" style={pill} data-testid="clip-pill" onClick={props.onPasteClipboard}>
        {t('simpleB3LinkPaste', { host: props.clipboardHost })}
      </button>
    </div>) : null}

    <Field label={t('simpleMemoLabel')} htmlFor="req-memo">
      <textarea id="req-memo" style={textarea} rows={2} value={props.memo}
        placeholder={t('simpleMemoHint')} onChange={function (e) { props.onMemo(e.target.value); }} />
    </Field>
    <NoteBox><div>{t('simpleMemoLangNote')}</div></NoteBox>
    <NoteBox><div>{t('simpleB3LinkNote')}</div></NoteBox>

    <CtaBar isMobile={props.isMobile}>
      <button type="button" data-testid="link-cta" disabled={props.submitting}
        style={props.submitting ? Object.assign({}, btnNavy, btnDisabled, { flex: 1 }) : Object.assign({}, btnNavy, { flex: 1 })}
        onClick={props.onSubmit}>{t('simpleSubmit')}</button>
    </CtaBar>
  </React.Fragment>);
}

export default StepLink;
